import React, { useCallback, useEffect, useState, useRef } from "react";
import { useSelector, useDispatch/*, shallowEqual*/ } from "react-redux";
import { InfoWindowF, MarkerF/*, useGoogleMap*/ } from '@react-google-maps/api';
//import { remove_carecenters } from '../../features/CareCenterDataSlice';
//import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
// import carecenterIcon from '../../assets/carecentericon.svg';
// import MMWarriorSVG from '../../assets/patienticon.svg';
// import CaregiverSVG from '../../assets/caregiver.svg';
// import MedicSVG from '../../assets/medic.svg';
import { activateMarker } from "../../features/activeMarkers";// activateCareCenter, activateWarrior /*} from '../features/activeMarkers'
//import { useGetUserProfileQuery, isFetchBaseQueryError, isErrorWithMessage, FetchBaseQueryError } from '../../features/profilesSlice';
//import { skipToken } from '@reduxjs/toolkit/query';
import { useAuthProfile } from "../../app/hooks"
import { setPublicPinClicked /*, getProfileFromID, getAIProfileSummary */ } from "../../features/dataProcessingSlice"
import { GetUserTypePinPNG } from './MMMarkers';
import { PinChip } from "../MessageProfile";
import { Box, Button, IconButton, Tooltip, Stack } from "@mui/material";
import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined';
import { customIcon, setupMarkerTapAndHold, useZoomIconSync } from "./MMMarkers"
import { AppDispatch } from "../../app/store";
import { showProfile } from "../../features/dialogSlice";
//import { chatApi } from "../../features/ChatSlice";
//import EditNoteIcon from '@mui/icons-material/EditNote';
import EditIcon from '@mui/icons-material/Edit';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import CloseIcon from '@mui/icons-material/Close';
import { setActivePinModal, setBottomSheetState } from '../../features/utilitySlice';
import { useIsMobile } from '../../app/IsMobileContext';

// Module-level ref so CenterMapHome can access the underlying google.maps.Marker
export const userMarkerRef: React.MutableRefObject<any> = React.createRef()

// Mutable callback – replaced by the mounted component instance.
// CenterMapHome calls this after panning to replay the DROP→BOUNCE→InfoWindow animation.
export let triggerUserMarkerClick: (() => void) | null = null

export const UserMarkerNotMemoized: React.FC = () => {
  const markerRef = useRef<any>(null);
  const lastAnimationRef = useRef<number | null>(0);
  //const AIState = useSelector((state: any) => state.dataProcessing)

  const { authStatus, profile, isLoading, isSuccess, isError /*, error, userAttributesStateStatus*/ } = useAuthProfile()

  const [showinfoWindowAfterAnimation, setShowinfoWindowAfterAnimation] = useState(false);
  const [infoWindowOpen, setInfoWindowOpen] = useState(false);
  const dispatch = useDispatch()
  const isMobile = useIsMobile()
  const isMobileRef = useRef(isMobile)
  useEffect(() => { isMobileRef.current = isMobile }, [isMobile])

  //const [animationEnded, setAnimationEnded] = useState(false);
  //const markerLib = useMapsLibrary("marker");
  const markerType = authStatus === 'authenticated' ? profile?.type : undefined
  // const userTypePin = {
  //   url: markerType === "P" ? patientIcon : markerType === "C" ? caregiverIcon : markerType === "M" ? medicIcon : carecenterIcon,
  // };

  //const activeMarkers = useSelector(state:any) => state.activeMarkers);
  const isMarkerActive = useSelector(
    (state: any) => {
      if (state.activeMarkers?.id && state.activeMarkers?.id === profile?.id) {
        return true
      }
      return false
    }
  );

  const userTypePinSVG = GetUserTypePinPNG(markerType)
  const sizeRef = useZoomIconSync(markerRef, userTypePinSVG as string | null)

  useEffect(() => {
    if (markerRef.current) {
      if (!lastAnimationRef.current ) {//window.google.maps.Animation.DROP ){
        lastAnimationRef.current = 2
        markerRef.current.setAnimation(2);
        return
      }
    }
  }, [profile?.type, profile?.lat, profile?.lng])//center.lat, center.lng,


  const handleAnimationChange = () => {
    if (markerRef.current) {
      const currentAanimation = markerRef.current.getAnimation()
      if (currentAanimation === null) {
        if (lastAnimationRef.current === 2) {
          markerRef.current.setAnimation(window.google.maps.Animation.BOUNCE);
          lastAnimationRef.current = 1 
          const timer1 = setTimeout(() => {
            markerRef.current.setAnimation(null);
            dispatch(activateMarker({ id: profile.id, disableHover: true }))
           setShowinfoWindowAfterAnimation(true)
            lastAnimationRef.current = null
          }, 1000);
          return () => { clearTimeout(timer1) };
        }
      }
      // if (currentAanimation === null) {
      //   if (lastAnimationRef.current  && !showinfoWindowAfterAnimation) {// multiple listeners?          
      //     dispatch(activateMarker({ id: profile.id, disableHover: true }))
      //     setShowinfoWindowAfterAnimation(true)
      //   }
      // } else {
      //   lastAnimationRef.current = markerRef.current.getAnimation()
      //   //setAnimationEnded( true)
      // }
    }
  }




  // Callable from outside (e.g. CenterMapHome) — pans the map to the marker,
  // then triggers the hero morph animation (mobile) or DROP→BOUNCE→InfoWindow (desktop).
  const replayAnimation = useCallback(() => {
    const marker = markerRef.current
    if (!marker) return
    const map = marker.getMap()
    if (!map) return

    // Reset animation state
    lastAnimationRef.current = 0
    setShowinfoWindowAfterAnimation(false)
    setInfoWindowOpen(false)

    // Zoom in close and pan the Google Map to the marker's position
    const pos = marker.getPosition()
    if (pos) {
      if (map.getZoom() < 12) {
        map.setZoom(14)
      }
      map.panTo(pos)
    }

    // After the pan completes, open the hero modal (mobile) or play the drop (desktop).
    let fired = false
    const afterPan = () => {
      if (fired) return
      fired = true
      if (!markerRef.current) return

      if (isMobileRef.current) {
        // Mobile: compute the marker's screen position via OverlayView, then
        // dispatch setActivePinModal with heroInfo to trigger the hero morph.
        const overlay = new window.google.maps.OverlayView()
        overlay.draw = () => {}
        overlay.onAdd = () => {
          const proj = overlay.getProjection()
          if (proj && pos) {
            const px = proj.fromLatLngToContainerPixel(pos)
            if (px) {
              const mapRect = (map.getDiv() as HTMLElement).getBoundingClientRect()
              dispatch(activateMarker({ id: profile.id, disableHover: true }))
              setInfoWindowOpen(false)
              dispatch(setActivePinModal({
                data: profile,
                category: 'ownUser',
                heroInfo: userTypePinSVG
                  ? { screenX: mapRect.left + px.x, screenY: mapRect.top + px.y - sizeRef.current / 2, iconUrl: userTypePinSVG as string, iconSize: sizeRef.current }
                  : undefined,
              }))
            }
          }
          overlay.setMap(null)
        }
        overlay.setMap(map)
      } else {
        // Desktop: replay DROP → BOUNCE → InfoWindow chain
        lastAnimationRef.current = 2
        markerRef.current.setAnimation(window.google.maps.Animation.DROP)
      }
    }
    window.google.maps.event.addListenerOnce(map, 'idle', () => setTimeout(afterPan, 600))
    // Fallback: if map was already centered, panTo is a no-op and idle won't fire
    setTimeout(afterPan, 1400)
  }, [dispatch, profile, userTypePinSVG])

  // Keep the module-level callback in sync with the mounted instance
  useEffect(() => {
    triggerUserMarkerClick = replayAnimation
    return () => { triggerUserMarkerClick = null }
  }, [replayAnimation])

  function onLoad(marker: any) {
    markerRef.current = marker
    ;(userMarkerRef as React.MutableRefObject<any>).current = marker
    setupMarkerTapAndHold(marker, {
      isMobileRef,
      dispatch,
      activateId: profile.id,
      setInfoWindowOpen,
      buildPayload: (c) => ({
        data: profile, category: 'ownUser',
        heroInfo: userTypePinSVG
          ? { screenX: c.sx, screenY: c.sy, iconUrl: userTypePinSVG as string, iconSize: sizeRef.current }
          : undefined,
      }),
      onDesktopClick: () => {
        dispatch(setPublicPinClicked(profile.id))
        dispatch(activateMarker({ id: profile.id, disableHover: true }))
        setInfoWindowOpen(false)
      },
    })
  }


  const handleMouseOver = () => {
    if (isMarkerActive) {//if (activeMarkers.disableHover) {
      return;
    }
    setInfoWindowOpen(true);

    //activateCallBack(id)
  };

  const handleMouseOut = () => {
    if (isMarkerActive) {//if (activeMarkers.disableHover) {
      return;
    }
    setInfoWindowOpen(false);
  };

  function handleWindowClose() {
    setInfoWindowOpen(false);
    dispatch(activateMarker({ id: null, disableHover: false }))
    dispatch(setPublicPinClicked(false))
  };

  if (authStatus === 'unauthenticated' || !profile?.is_completed || isLoading || isError)
    return null

  if (isSuccess)
    return (
      <MarkerF
        //key={`marker-user-${zoom}`}
        onLoad={onLoad}
        animation={window.google.maps.Animation.DROP}
        position={{ lat: profile.lat, lng: profile.lng }}
        icon={customIcon(userTypePinSVG as unknown as string, sizeRef.current)}
        onMouseOver={() => handleMouseOver()}
        onMouseOut={() => handleMouseOut()}
        //onClick={(e) => handleClick(e)}
        onAnimationChanged={() => handleAnimationChange()}
      >
        {!isMobile && ((isMarkerActive && showinfoWindowAfterAnimation) || infoWindowOpen) && (
          <InfoWindowF
            options={{ disableAutoPan: true }}
            position={{ lat: profile.lat, lng: profile.lng }}
            onCloseClick={() => handleWindowClose()}>
            <UserMarkerInfoWindowDetails data={profile} onClose={handleWindowClose} />
          </InfoWindowF>
        )}
      </MarkerF>
    );
  return null
}


export const UserMarkerInfoWindowDetails: React.FC<{ data: any, onClose?: () => void, children?: React.ReactNode, containerSx?: object }> = ({ data, onClose, children, containerSx }) => {
  const dispatch = useDispatch<AppDispatch>()
  function handleClick() {
    dispatch(setPublicPinClicked(data.id))
    dispatch(setBottomSheetState(true))
    dispatch(setActivePinModal(null))
  }
  return (
    <Stack direction="column" sx={{ width: '280px', maxHeight: '360px', overflow: 'hidden', borderRadius: '12px', background: 'linear-gradient(145deg, rgba(244, 240, 255, 0.97) 0%, rgba(236, 232, 250, 0.95) 50%, rgba(244, 240, 255, 0.97) 100%)', border: '1px solid rgba(164, 142, 233, 0.22)', boxShadow: '0 8px 32px rgba(101, 110, 255, 0.12), 0 2px 8px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.6)', ...containerSx }}>
      {/* Colored header — name + edit + close */}
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between"
        sx={{ background: 'linear-gradient(135deg, rgba(139,92,246,0.85) 0%, rgba(165,120,255,0.80) 100%)', px: 1.5, py: 1, flexShrink: 0, borderRadius: '12px 12px 0 0', boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.3)' }}>
        <Typography sx={{ color: 'white', fontWeight: 700, fontSize: '0.875rem', lineHeight: 1.3, flexGrow: 1, pr: 0.5 }}>
          {data.name_public}
        </Typography>
        <Stack direction="row" sx={{ flexShrink: 0, mt: '-2px', mr: '-4px' }}>
          <Tooltip title="View my profile" placement="top">
            <IconButton size="small" onClick={handleClick}
              sx={{ p: 0.25, color: 'rgba(255,255,255,0.8)', '&:hover': { color: 'white', bgcolor: 'rgba(255,255,255,0.15)' } }}>
              <MenuBookIcon sx={{ fontSize: '1rem' }} />
            </IconButton>
          </Tooltip>
          {onClose && (
            <IconButton size="small" onClick={onClose}
              sx={{ p: 0.25, color: 'rgba(255,255,255,0.8)', '&:hover': { color: 'white', bgcolor: 'rgba(255,255,255,0.15)' } }}>
              <CloseIcon sx={{ fontSize: '1rem' }} />
            </IconButton>
          )}
        </Stack>
      </Stack>

      {/* Fixed: badge+address + CTA — never scroll away */}
      <Stack direction="column" gap={0.75} sx={{ px: 1.5, pt: 1, pb: 0.5, flexShrink: 0 }}>
        <Stack direction="row" gap={1} alignItems="center" sx={{ overflow: 'hidden' }}>
          <PinChip category="User" type={data.type} size="small" iconSizePx={16} sx={{ pt: 0.5, pb: 0.5, height: '24px', fontSize: '0.7rem', flexShrink: 0 }} />
          <Stack direction="row" gap={0.5} alignItems="flex-start" sx={{ minWidth: 0, overflow: 'hidden' }}>
            <RoomOutlinedIcon sx={{ fontSize: '0.875rem', color: 'primary.main', flexShrink: 0, mt: '1px' }} />
            <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.3 }}>{data.formattedsearchterm}</Typography>
          </Stack>
        </Stack>
        <Button
          variant="outlined"
          color="primary"
          size="small"
          startIcon={<MenuBookIcon />}
          disableElevation
          onClick={handleClick}
          sx={{ textTransform: 'none', fontSize: '0.75rem' }}
        >
          View my profile
        </Button>
      </Stack>

      {/* Scrollable: comment only */}
      <Stack direction="column" gap={0.75} sx={{ px: 1.5, pb: 1, overflow: 'auto', flexGrow: 1 }}>
        {data.comment && (
          <Box sx={{ borderLeft: '3px solid #E0DEFF', pl: 1.5, py: 0.5, backgroundColor: '#FAFAFA', borderRadius: 1 }}>
            <Typography variant="body2" sx={{ color: '#555', lineHeight: 1.6, whiteSpace: 'pre-line' }}>{data.comment}</Typography>
          </Box>
        )}
        <div>{children}</div>
      </Stack>
    </Stack>
  );
}

export const UserMarker = React.memo(UserMarkerNotMemoized);